// extracted by mini-css-extract-plugin
module.exports = {"article":"article_article__3tTrV","articleDark":"article_articleDark__EGEFQ"};